export default __webpack_public_path__ + "static/kara-rui-b4fec734395b3e51972470499e62c332.webp";